import React, { useEffect, useState } from "react";
import { permisions } from "../../../utils/helpers";
import PermisosSelection from "./PermisosSelection";
import { auth } from "../../../utils/auth";

const Permisos = ({permisosUsuario, rol}) => {
    const grupoA = [
        {
            label: 'Inicio',
            value: permisions.verDashboard,
        },
        {
            label: 'Dashboard vendedores',
            value: permisions.dashboardVendedores,
        },
        {
            label: 'Contabilidad',
            value: permisions.verContabilidad,
            children: [
                // { label: 'Contabilidad', value: permisions.verContabilidad},
                { label: 'Bancos', value: permisions.verCuentas},
                { label: 'Cheque', value: permisions.verCheque},
                { label: 'Cuenta Contable', value: permisions.verCuentaContable},
                { label: 'Entradas de Diario', value: permisions.verEntradasDiarios},
                { label: 'Reporte Contables', value: permisions.verReporteContables},
                
            ],
        },
        {
            label: 'Contratos',
            value: permisions.verContratos,
        },
        {
            label: 'Ingresos',
            value: permisions.verIngresos,
            children: [
                { value: permisions.verCotizaciones, label: 'Cotizaciones'},
                { value: permisions.verPedidos, label: 'Pedidos'},
                { value: permisions.verFacturas, label: 'Facturas'},
                { value: permisions.verFacturasRecurrentes, label: 'Facturas Recurrentes'},
                { value: permisions.verNotasCredito, label: 'Notas de crédito'},
                { value: permisions.verNotasDebito, label: 'Notas de débito'},
                { value: permisions.verDespachoFacturas, label: 'Despacho de Facturas'},
                { value: permisions.verCuadreCaja, label: 'Cuadre de Caja'},
            ],
        },
        {
            label: 'Egresos',
            value: permisions.verEgresos,
            children: [
                { value: permisions.verCompras, label: 'Compras'},
                { value: permisions.verComprasRecurrentes, label: 'Compras Recurrentes'},
                { value: permisions.verOrdenesCompra, label: 'Ordenes de Compra'},
                { value: permisions.verNotasCredito, label: 'Notas de crédito'},
            ],
        },
        {
            label: 'Consultas',
            value: permisions.verConsultas,
            children: [
                { value: permisions.verCuentasPorCobrar, label: 'Cuentas por cobrar'},
                { value: permisions.verCuentasPorPagar, label: 'Cuentas por pagar'},
                { value: permisions.verRecibosIngreso, label: 'Recibos'},
            ],
        },
        {
            label: 'Reportes',
            value: permisions.verReportes,
        },
        {
            label: 'Salud',
            value: permisions.salud,
            children: [
                { label: 'Salud DashBoard', value: permisions.salud },
                { label: 'Visitas', value: permisions.visitaSalud, hasNoEdit: true },
                { label: 'Pacientes', value: permisions.pacientes, hasNoEdit: true },
                { label: 'Insumos', value: permisions.inventarioSalud },
            ],
        },
        {
            label: 'Empleados',
            value: permisions.verEmpleados,
            children:
            [
                { label: 'Listado', value: permisions.verEmpleados, hasNoEdit: true },
                { label: 'Tipos Empleados', value: permisions.verTipos, hasNoEdit: true },
                { label: 'Grupos Tipos', value: permisions.verGrupoTiposEmpleados, hasNoEdit: true },
            ]
        },
    ];
    const grupoB = [
        {
            label: 'Ausencias',
            value: permisions.verAusencias,
        },
        {
            label: 'Cartas',
            value: permisions.verCarta,
            children: [
                { label: 'Listado', value: permisions.verCartas, hasNoEdit: true },
                { label: 'Plantillas', value: permisions.verPlantillas },
            ],
        },
        {
            label: 'Nómina',
            value: permisions.verNomina,
            children: [
                { label: 'Historial', value: permisions.verNomina },
                { label: 'Descuentos', value: permisions.verDescuentos },
                { label: 'Incentivos', value: permisions.verIncentivos },
            ],
        },
        {
            label: 'Tareas',
            value: permisions.verSolicitudes,
        },
        {
            label: 'Vehículos',
            value: permisions.verVehiculos,
            children: [
                { label: 'Listado', value: permisions.verVehiculos },
                { label: 'Servicios', value: permisions.verServicios },
            ],
        },
        {
            label: 'Inventario',
            value: permisions.verInventario,
            children: [
                { value: permisions.verProductos, label: 'Productos', children: [
                    { value: permisions.crearProductos, label: 'Crear'},
                    { value: permisions.editarProductos, label: 'Editar'},
                    { value: permisions.eliminarProductos, label: 'Eliminar'},
                    { value: permisions.movimientoMasivos, label: 'Movimiento masivos'},
                    { value: permisions.exportarCatalogo, label: 'Exportar Catálogo'},
                ]},
                { value: permisions.verCategorias, label: 'Categorías'},
                { value: permisions.verAlmacenes, label: 'Almacenes'},
                { value: permisions.verUbicaciones, label: 'Ubicaciones'},
                { value: permisions.verGastos, label: 'Despacho interno', children: [
                    { value: permisions.crearGastos, label: 'Crear'},
                    { value: permisions.editarGastos, label: 'Editar'},
                ]},
                { value: permisions.verActivoFijo, label: 'Activo Fijo', children: [
                    { value: permisions.crearActivoFijo, label: 'Crear'},
                    { value: permisions.editarActivoFijo, label: 'Editar'},
                ] },
            ],
        },
        {
            label: 'Contactos',
            value: permisions.verContactos,
        },
        {
            label: 'Zonas',
            value: permisions.verRutas,
        },
        
        // {
        //     label: 'Gastos Generales',
        //     value: permisions.verGastosGenerales,
        // },
        {
            label: 'Configuraciones',
            value: permisions.verConfiguracion,
            children: [
                {value: permisions.verConfiguracion, label: 'Ver Configuraciones'},
                {value: permisions.editarUsuarios, label: 'Editar Usuarios'},
                {value: permisions.editarSucursales, label: 'Editar Sucursales'},
            ],
        },
    ];

    const [currentPermission, setCurrentPermission] = useState(
        new Set([
            ...(rol ? (rol in auth.permissions ? auth.permissions[rol] : []) : []),
            ...(permisosUsuario ?? []),
        ])
    );

    const addToCurrent = (permissions) => {
        setCurrentPermission((prev) => new Set([...prev, ...permissions]));
    };

    const removeFromCurrent = (permissions) => {
        setCurrentPermission((prev) => {
            const next = new Set(prev);

            for (const permission of permissions) {
                next.delete(permission);
            }

            return next;
        });
    };

    return <>
        <div className="form-group row">
            <div className="col-12 py-1" style={{lineHeight: 1.1}}>
                <label style={{fontSize: '18px', fontWeight: 700, color: '#333'}}>Permisos</label>

                <span style={{color: '#777', fontSize: '14px'}}>Selecciona los módulos y permisos que tendrá este usuario</span>
            </div>
        </div>

        <div className="row" style={{height: 'calc(100% - 60px)'}}>
            {[...currentPermission].filter((permission) => permission).map((permission, index) => <input type="hidden" name="permisos[]" value={permission} key={`permisos[${index}]`} />)}
            <div className="col-6" style={{height: '100%'}}>
                <div style={{width: '100%', height: '100%' }}>
                    {grupoA.map((session, index) =>
                        <PermisosSelection key={`session[${index}]`} label={session.label} value={session.value} children={session.children} current={[...currentPermission]} add={addToCurrent} remove={removeFromCurrent} />
                    )}
                </div>
            </div>

            <div className="col-6" style={{height: '100%'}}>
                <div style={{width: '100%', height: '100%' }}>
                    {grupoB.map((session, index) =>
                        <PermisosSelection key={`session[${index}]`} label={session.label} value={session.value} children={session.children} current={[...currentPermission]} add={addToCurrent} remove={removeFromCurrent} />
                    )}
                </div>
            </div>
        </div>
    </>;
};

export default Permisos
